export default "__VITE_ASSET__BRbJXUla__"